import { ENV_MAP, type Environment } from '@aslanpay/portal-common-lib';
import appEnv from 'app/config/appEnv';

export const getEnvironment = (): Environment =>
  ENV_MAP[appEnv.VITE_ENV?.toLowerCase()] ?? 'Development';

export default getEnvironment;
